import { ALLOCATION_PLANS_THEME } from '../../../../lumpsum/plans-list/header/common/riskProfileHeaderTheme'

export function SipPlanRecommendationSheetSkeleton() {
  return (
    <div className="pb-2">
      <div className="px-5">
        <div className="flex flex-col gap-2">
          <div className="text-[14px] font-[500] leading-[130%]" style={{ color: ALLOCATION_PLANS_THEME.headerTextColor }}>
            Allocation Recommendation
          </div>
          <div className="skeleton h-[52px] w-full max-w-[85%] rounded-[4px]" />
        </div>
      </div>
      <div className="px-5 pt-9">
        <div className="skeleton h-[160px] w-full rounded-[12px]" />
      </div>
      <div className="mt-6 h-[10px] bg-[#F0F4F7]" />
      <div className="px-5 pt-6">
        <div className="skeleton h-[24px] w-[220px] rounded-[4px]" />
        <div className="pt-4 skeleton h-[120px] w-full rounded-[12px]" />
      </div>
    </div>
  )
}
